import { inject, Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';

// rxjs
import { Observable } from 'rxjs';

// services
import { AccountService } from '@core/services/account/account.service';
import { X_REQUEST_TYPE_ID } from '@core/constants';

@Injectable()
export class XRequestTypeIdInterceptor implements HttpInterceptor {
  private readonly accountService = inject(AccountService);
  private readonly currentUser = this.accountService.$currentUser;

  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const currentUser = this.currentUser();

    if (currentUser) {
      request = request.clone({
        setHeaders: {
          [X_REQUEST_TYPE_ID]: currentUser.id.toString(),
        },
      });
    }

    return next.handle(request);
  }
}
